export default __webpack_public_path__ + "static/media/youtube-dislike-png-45967.61581778.png";